import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import Grid from '@/global/components/ui/Grid'
import { Button } from 'global/components/Button'
import { FormField } from 'global/components/Form'
import { SelectFuncionarios } from 'global/components/Selects'
import ContentGuide from 'global/guides/ContentGuide/ContentGuide'
import { queryClient } from 'providers/ReactQuery'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useQuery } from 'react-query'
import { local } from 'service/api'
import { toast } from 'sonner'
import { DesassociarFuncionarioLocal } from '../modals/DesassociarFuncionario'

export const AssociarFuncionarioForm = () => {
    const { mutate } = local.funcionarios.mutations.useCreate()
    const { watch } = useFormContext<{ id: number }>()
    const { id } = watch()
    const { data, isLoading } = useQuery(['local', id], () => local.getById(id))

    const [checkedIds, setCheckedIds] = useState<number[]>([])
    const checked = data?.FuncionarioLocais?.map(item => item.funcionarioId)

    const handleChange = (ids: number[]) => {
        setCheckedIds(ids)
    }

    const handleClick = () => {
        checkedIds.forEach(funcionarioId =>
            mutate(
                { funcionarioId, localId: id },
                {
                    onSuccess: () => {
                        toast.success('Funcionário associado com sucesso')
                        queryClient.invalidateQueries(['local', id])
                    },

                    onError: () => {
                        toast.error('Erro ao associar funcionário')
                        setCheckedIds(prev => [...prev, funcionarioId])
                    },
                },
            ),
        )

        setCheckedIds([])
    }

    return (
        <Grid container className="items-start">
            <Grid item xs={9}>
                <SelectFuncionarios
                    variant="form"
                    form
                    checked={checked}
                    onChange={handleChange}
                />
            </Grid>
            <Grid item xs={3}>
                <Button
                    fullWidth
                    size="large"
                    onClick={handleClick}
                    disabled={!checkedIds.length}
                >
                    Associar
                </Button>
            </Grid>
            <Grid item xs={12} className="min-h-96">
                <ContentGuide.DataGrid
                    loading={isLoading}
                    columns={[
                        {
                            field: 'Funcionario',
                            headerName: 'Nome',
                            flex: 1,
                            valueGetter: ({ value }) => value.nome,
                        },
                        {
                            ...optionsColumn,
                            field: '__desassociar',
                            renderCell: DesassociarFuncionarioLocal,
                        },
                    ]}
                    rows={data?.FuncionarioLocais ?? []}
                    ToolbarProps={{ hideToolbar: true }}
                    hideFooter
                />
            </Grid>
            <FormField name="id" hidden />
        </Grid>
    )
}
